import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../../../DatiSpecifici/DatiSpecifici.module.css";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Select from "../../../../../../../components/select/Select";
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json";
import Utils from "../../../../../../../utils/Utils";

class caratteristicheDellaDiagnosiTubercolosi extends Component {

    state = {
        caratteristicheDellaDiagnosi: {
            esameColturaleEscreato: "",
            esameColturaleAltroMateriale: "",
            materialeEsameColturaleAltroMateriale: "",
            esameDirettoEscreato: "",
            esameDirettoAltroMateriale: "",
            materialeEsameDirettoAltroMateriale: "",
            clinica: "",
            mantoux: "",
            rxToraceEsamiStrumentali: "",
            rispostaAllaTerapia: "",
            riscontroAutopicoTb: "",
            motivoIterDiagnostico: "",
            eventualeCasoIterDiagnostico: "",
            screeningContatti: "",
            gruppiARischio: "",
            fattoreDiRischio: "",
            corretto: []
        },
        boxes: []
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
        this.createOggettoBE = this.createOggettoBE.bind(this)
        this.div = this.div.bind(this)
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.caratteristicheDellaDiagnosi) {
            let caratteristicheDellaDiagnosi = this.state.caratteristicheDellaDiagnosi
            let caratteristicheDellaDiagnosiProps = this.props.segnalazioneCopia.schedaSpeciale.caratteristicheDellaDiagnosi

            caratteristicheDellaDiagnosi.esameColturaleEscreato = caratteristicheDellaDiagnosiProps.esameColturaleEscreato ? caratteristicheDellaDiagnosiProps.esameColturaleEscreato : this.state.caratteristicheDellaDiagnosi.esameColturaleEscreato
            caratteristicheDellaDiagnosi.esameColturaleAltroMateriale = caratteristicheDellaDiagnosiProps.esameColturaleAltroMateriale ? caratteristicheDellaDiagnosiProps.esameColturaleAltroMateriale : this.state.caratteristicheDellaDiagnosi.esameColturaleAltroMateriale
            caratteristicheDellaDiagnosi.materialeEsameColturaleAltroMateriale = caratteristicheDellaDiagnosiProps.materialeEsameColturaleAltroMateriale ? caratteristicheDellaDiagnosiProps.materialeEsameColturaleAltroMateriale : this.state.caratteristicheDellaDiagnosi.materialeEsameColturaleAltroMateriale
            caratteristicheDellaDiagnosi.esameDirettoEscreato = caratteristicheDellaDiagnosiProps.esameDirettoEscreato ? caratteristicheDellaDiagnosiProps.esameDirettoEscreato : this.state.caratteristicheDellaDiagnosi.esameDirettoEscreato
            caratteristicheDellaDiagnosi.esameDirettoAltroMateriale = caratteristicheDellaDiagnosiProps.esameDirettoAltroMateriale ? caratteristicheDellaDiagnosiProps.esameDirettoAltroMateriale : this.state.caratteristicheDellaDiagnosi.esameDirettoAltroMateriale
            caratteristicheDellaDiagnosi.materialeEsameDirettoAltroMateriale = caratteristicheDellaDiagnosiProps.materialeEsameDirettoAltroMateriale ? caratteristicheDellaDiagnosiProps.materialeEsameDirettoAltroMateriale : this.state.caratteristicheDellaDiagnosi.materialeEsameDirettoAltroMateriale
            caratteristicheDellaDiagnosi.clinica = caratteristicheDellaDiagnosiProps.clinica ? caratteristicheDellaDiagnosiProps.clinica : this.state.caratteristicheDellaDiagnosi.clinica
            caratteristicheDellaDiagnosi.mantoux = caratteristicheDellaDiagnosiProps.mantoux ? caratteristicheDellaDiagnosiProps.mantoux : this.state.caratteristicheDellaDiagnosi.mantoux
            caratteristicheDellaDiagnosi.rxToraceEsamiStrumentali = caratteristicheDellaDiagnosiProps.rxToraceEsamiStrumentali ? caratteristicheDellaDiagnosiProps.rxToraceEsamiStrumentali : this.state.caratteristicheDellaDiagnosi.rxToraceEsamiStrumentali
            caratteristicheDellaDiagnosi.riscontroAutopicoTb = caratteristicheDellaDiagnosiProps.riscontroAutopicoTb ? caratteristicheDellaDiagnosiProps.riscontroAutopicoTb : this.state.caratteristicheDellaDiagnosi.riscontroAutopicoTb
            caratteristicheDellaDiagnosi.motivoIterDiagnostico = caratteristicheDellaDiagnosiProps.motivoIterDiagnostico ? caratteristicheDellaDiagnosiProps.motivoIterDiagnostico : this.state.caratteristicheDellaDiagnosi.motivoIterDiagnostico
            caratteristicheDellaDiagnosi.icd9L2 = caratteristicheDellaDiagnosiProps.icd9L2 ? caratteristicheDellaDiagnosiProps.icd9L2 : this.state.caratteristicheDellaDiagnosi.icd9L2
            caratteristicheDellaDiagnosi.eventualeCasoIterDiagnostico = caratteristicheDellaDiagnosiProps.eventualeCasoIterDiagnostico ? caratteristicheDellaDiagnosiProps.eventualeCasoIterDiagnostico : this.state.caratteristicheDellaDiagnosi.eventualeCasoIterDiagnostico
            caratteristicheDellaDiagnosi.screeningContatti = caratteristicheDellaDiagnosiProps.screeningContatti ? caratteristicheDellaDiagnosiProps.screeningContatti : this.state.caratteristicheDellaDiagnosi.screeningContatti
            caratteristicheDellaDiagnosi.gruppiARischio = caratteristicheDellaDiagnosiProps.gruppiARischio ? caratteristicheDellaDiagnosiProps.gruppiARischio : this.state.caratteristicheDellaDiagnosi.gruppiARischio
            caratteristicheDellaDiagnosi.rispostaAllaTerapia = caratteristicheDellaDiagnosiProps.rispostaAllaTerapia ? caratteristicheDellaDiagnosiProps.rispostaAllaTerapia : this.state.caratteristicheDellaDiagnosi.rispostaAllaTerapia
            caratteristicheDellaDiagnosi.fattoreDiRischio = caratteristicheDellaDiagnosiProps.fattoreDiRischio ? caratteristicheDellaDiagnosiProps.fattoreDiRischio : this.state.caratteristicheDellaDiagnosi.fattoreDiRischio


            this.setState({caratteristicheDellaDiagnosi: caratteristicheDellaDiagnosi});
        }
        this.div()
        this.controlloCorrettezza()
        let oggetto = this.createOggettoBE()
        this.props.setCaratteristicheDellaDiagnosiTubercolosi(this.state.caratteristicheDellaDiagnosi, oggetto)
    }

    riceviValore(field, event) {
        let caratteristicheDellaDiagnosi = this.state.caratteristicheDellaDiagnosi
        caratteristicheDellaDiagnosi[field] = event.target.value
        if (caratteristicheDellaDiagnosi.esameColturaleAltroMateriale !== "1") {
            caratteristicheDellaDiagnosi.materialeEsameColturaleAltroMateriale = ""
        }
        if (caratteristicheDellaDiagnosi.esameDirettoAltroMateriale !== "1") {
            caratteristicheDellaDiagnosi.materialeEsameDirettoAltroMateriale = ""
        }
        if (caratteristicheDellaDiagnosi.motivoIterDiagnostico !== "2") {
            caratteristicheDellaDiagnosi.eventualeCasoIterDiagnostico = ""
        }
        if (caratteristicheDellaDiagnosi.eventualeCasoIterDiagnostico !== "01") {
            caratteristicheDellaDiagnosi.screeningContatti = ""
        }
        if (caratteristicheDellaDiagnosi.eventualeCasoIterDiagnostico !== "02") {
            caratteristicheDellaDiagnosi.gruppiARischio = ""
        }
        if (caratteristicheDellaDiagnosi.gruppiARischio === "") {
            caratteristicheDellaDiagnosi.fattoreDiRischio = ""
        }
        if (caratteristicheDellaDiagnosi.gruppiARischio === "1" && caratteristicheDellaDiagnosi.fattoreDiRischio.includes("B")) {
            caratteristicheDellaDiagnosi.fattoreDiRischio = ""
        }
        if (caratteristicheDellaDiagnosi.gruppiARischio === "2" && caratteristicheDellaDiagnosi.fattoreDiRischio.includes("A")) {
            caratteristicheDellaDiagnosi.fattoreDiRischio = ""
        }
        this.setState({caratteristicheDellaDiagnosi: caratteristicheDellaDiagnosi})
        this.div()
        this.controlloCorrettezza()
        this.props.controlloCorrettezza()
        let oggetto = this.createOggettoBE()
        this.props.setCaratteristicheDellaDiagnosiTubercolosi(this.state.caratteristicheDellaDiagnosi, oggetto)
    }

    controlloCorrettezza() {
        let caratteristiche = this.state.caratteristicheDellaDiagnosi
        caratteristiche.corretto = []

        if(!caratteristiche.esameColturaleEscreato) caratteristiche.corretto[0] = "Campo \"Esame colturale escreato\" mancante";
        if(!caratteristiche.esameColturaleAltroMateriale) caratteristiche.corretto[1] = "Campo \"Esame colturale altro materiale\" mancante";
        if(!caratteristiche.esameDirettoEscreato) caratteristiche.corretto[2] = "Campo \"Esame diretto escreato\" mancante";
        if(!caratteristiche.esameDirettoAltroMateriale) caratteristiche.corretto[3] = "Campo \"Esame diretto altro materiale\" mancante";
        if(!caratteristiche.clinica) caratteristiche.corretto[4] = "Campo \"Clinica\" mancante";
        if(!caratteristiche.mantoux) caratteristiche.corretto[5] = "Campo \"Mantoux\" mancante";
        if(!caratteristiche.rxToraceEsamiStrumentali) caratteristiche.corretto[6] = "Campo \"Rx torace/esami strumentali\" mancante";
        if(!caratteristiche.rispostaAllaTerapia) caratteristiche.corretto[7] = "Campo \"Risposta alla terapia\" mancante";
        if(!caratteristiche.riscontroAutopicoTb) caratteristiche.corretto[8] = "Campo \"Riscontro autopico TB attiva\" mancante";
        if(!caratteristiche.motivoIterDiagnostico) caratteristiche.corretto[9] = "Campo \"Motivo dell'Iter Diagnostico\" mancante";

        if(caratteristiche.esameColturaleAltroMateriale === "1" && !caratteristiche.materialeEsameColturaleAltroMateriale) caratteristiche.corretto[10] = "Campo \"Esame colturale altro materiale - Se positivo, specificare\" mancante";
        if(caratteristiche.esameDirettoAltroMateriale === "1" && !caratteristiche.materialeEsameDirettoAltroMateriale) caratteristiche.corretto[11] = "Campo \"Esame diretto altro materiale - Se positivo, specificare\" mancante";

        if((caratteristiche.motivoIterDiagnostico === "2" && !caratteristiche.eventualeCasoIterDiagnostico ) ||
            (caratteristiche.eventualeCasoIterDiagnostico === "01" && !caratteristiche.screeningContatti) ||
            (caratteristiche.eventualeCasoIterDiagnostico === "02" && (!caratteristiche.gruppiARischio || !caratteristiche.fattoreDiRischio))) caratteristiche.corretto[12] = "Campo \"Motivo dell'Iter Diagnostico - Caso individuato in caso di Screening\" mancante";

    }

    createOggettoBE() {
        let caratteristicheDellaDiagnosi = JSON.parse(JSON.stringify(this.state.caratteristicheDellaDiagnosi))
        let caratteristicheDellaDiagnosiBe = Utils.removeEmptyValueFromObject(caratteristicheDellaDiagnosi)
        return Utils.removeFieldFromObject(caratteristicheDellaDiagnosiBe, "corretto")
    }

    div() {

        const {t} = this.props

        let rows = [
            {
                label: {
                    text: "SchedaSpecialeTubercolosi.esameColturaleEscreato",
                    tipo: "label",
                    colonna: 1,
                    asterisco: true
                },
                esameColturaleEscreatoSi: {
                    id: "esameColturaleEscreatoSi",
                    text: "SchedaSpecialeTubercolosi.positivo",
                    tipo: "radio",
                    name: "esameColturaleEscreato",
                    value: "1",
                    colonna: 2,
                    smallLabel: true
                },
                esameColturaleEscreatoNo: {
                    id: "esameColturaleEscreatoNo",
                    text: "SchedaSpecialeTubercolosi.negativo",
                    tipo: "radio",
                    name: "esameColturaleEscreato",
                    value: "2",
                    colonna: 3,
                    smallLabel: true
                },
                esameColturaleEscreatoNonEseguito: {
                    id: "esameColturaleEscreatoNonEseguito",
                    text: "SchedaSpecialeTubercolosi.nonEseguito",
                    tipo: "radio",
                    name: "esameColturaleEscreato",
                    value: "3",
                    colonna: 4,
                    smallLabel: true
                },
                esameColturaleEscreatoNonNoto: {
                    id: "esameColturaleEscreatoNonNoto",
                    text: "SchedaSpecialeTubercolosi.nonNoto",
                    tipo: "radio",
                    name: "esameColturaleEscreato",
                    value: "4",
                    colonna: 5,
                    smallLabel: true
                },

            },
            {
                label: {
                    text: "SchedaSpecialeTubercolosi.esameColturaleAltroMateriale",
                    tipo: "label",
                    colonna: 1,
                    asterisco: true
                },
                esameColturaleAltroMaterialeSi: {
                    id: "esameColturaleAltroMaterialeSi",
                    text: "SchedaSpecialeTubercolosi.positivo",
                    tipo: "radio",
                    name: "esameColturaleAltroMateriale",
                    value: "1",
                    colonna: 2,
                    smallLabel: true
                },
                esameColturaleAltroMaterialeNo: {
                    id: "esameColturaleAltroMaterialeNo",
                    text: "SchedaSpecialeTubercolosi.negativo",
                    tipo: "radio",
                    name: "esameColturaleAltroMateriale",
                    value: "2",
                    colonna: 3,
                    smallLabel: true
                },
                esameColturaleAltroMaterialeNonEseguito: {
                    id: "esameColturaleAltroMaterialeNonEseguito",
                    text: "SchedaSpecialeTubercolosi.nonEseguito",
                    tipo: "radio",
                    name: "esameColturaleAltroMateriale",
                    value: "3",
                    colonna: 4,
                    smallLabel: true
                },
                esameColturaleAltroMaterialeNonNoto: {
                    id: "esameColturaleAltroMaterialeNonNoto",
                    text: "SchedaSpecialeTubercolosi.nonNoto",
                    tipo: "radio",
                    name: "esameColturaleAltroMateriale",
                    value: "4",
                    colonna: 5,
                    smallLabel: true
                },
                materialeEsameColturaleAltroMateriale: {
                    id: "materialeEsameColturaleAltroMateriale",
                    field: "materialeEsameColturaleAltroMateriale",
                    text: "SchedaSpecialeTubercolosi.sepositivo",
                    tipo: "input",
                    disabled: this.state.caratteristicheDellaDiagnosi.esameColturaleAltroMateriale !== "1",
                    required: this.state.caratteristicheDellaDiagnosi.esameColturaleAltroMateriale === "1",
                    colonna: 6
                },
            },
            {
                label: {
                    text: "SchedaSpecialeTubercolosi.esameDirettoEscreato",
                    tipo: "label",
                    colonna: 1,
                    asterisco: true
                },
                esameDirettoEscreatoSi: {
                    id: "esameDirettoEscreatoSi",
                    text: "SchedaSpecialeTubercolosi.positivo",
                    tipo: "radio",
                    name: "esameDirettoEscreato",
                    value: "1",
                    colonna: 2,
                    smallLabel: true
                },
                esameDirettoEscreatoNo: {
                    id: "esameDirettoEscreatoNo",
                    text: "SchedaSpecialeTubercolosi.negativo",
                    tipo: "radio",
                    name: "esameDirettoEscreato",
                    value: "2",
                    colonna: 3,
                    smallLabel: true
                },
                esameDirettoEscreatoNonEseguito: {
                    id: "esameDirettoEscreatoNonEseguito",
                    text: "SchedaSpecialeTubercolosi.nonEseguito",
                    tipo: "radio",
                    name: "esameDirettoEscreato",
                    value: "3",
                    colonna: 4,
                    smallLabel: true
                },
                esameDirettoEscreatoNonNoto: {
                    id: "esameDirettoEscreatoNonNoto",
                    text: "SchedaSpecialeTubercolosi.nonNoto",
                    tipo: "radio",
                    name: "esameDirettoEscreato",
                    value: "4",
                    colonna: 5,
                    smallLabel: true
                },

            },
            {
                label: {
                    text: "SchedaSpecialeTubercolosi.esameDirettoAltroMateriale",
                    tipo: "label",
                    colonna: 1,
                    asterisco: true
                },
                esameDirettoAltroMaterialeSi: {
                    id: "esameDirettoAltroMaterialeSi",
                    text: "SchedaSpecialeTubercolosi.positivo",
                    tipo: "radio",
                    name: "esameDirettoAltroMateriale",
                    value: "1",
                    colonna: 2,
                    smallLabel: true
                },
                esameDirettoAltroMaterialeNo: {
                    id: "esameDirettoAltroMaterialeNo",
                    text: "SchedaSpecialeTubercolosi.negativo",
                    tipo: "radio",
                    name: "esameDirettoAltroMateriale",
                    value: "2",
                    colonna: 3,
                    smallLabel: true
                },
                esameDirettoAltroMaterialeNonEseguito: {
                    id: "esameDirettoAltroMaterialeNonEseguito",
                    text: "SchedaSpecialeTubercolosi.nonEseguito",
                    tipo: "radio",
                    name: "esameDirettoAltroMateriale",
                    value: "3",
                    colonna: 4,
                    smallLabel: true
                },
                esameDirettoAltroMaterialeNonNoto: {
                    id: "esameDirettoAltroMaterialeNonNoto",
                    text: "SchedaSpecialeTubercolosi.nonNoto",
                    tipo: "radio",
                    name: "esameDirettoAltroMateriale",
                    value: "4",
                    colonna: 5,
                    smallLabel: true
                },
                materialeEsameDirettoAltroMateriale: {
                    id: "materialeEsameDirettoAltroMateriale",
                    field: "materialeEsameDirettoAltroMateriale",
                    text: "SchedaSpecialeTubercolosi.sepositivo",
                    tipo: "input",
                    disabled: this.state.caratteristicheDellaDiagnosi.esameDirettoAltroMateriale !== "1",
                    required: this.state.caratteristicheDellaDiagnosi.esameDirettoAltroMateriale === "1",
                    colonna: 6
                },
            },
            {
                label: {text: "SchedaSpecialeTubercolosi.Clinica", tipo: "label", colonna: 1, asterisco: true},
                clinicaSi: {
                    id: "clinicaSi",
                    text: "SchedaSpecialeTubercolosi.positivo",
                    tipo: "radio",
                    name: "clinica",
                    value: "1",
                    colonna: 2,
                    smallLabel: true
                },
                clinicaNo: {
                    id: "clinicaNo",
                    text: "SchedaSpecialeTubercolosi.negativo",
                    tipo: "radio",
                    name: "clinica",
                    value: "2",
                    colonna: 3,
                    smallLabel: true
                },
                clinicaNonEseguito: {
                    id: "clinicaNonEseguito",
                    text: "SchedaSpecialeTubercolosi.nonEseguito",
                    tipo: "radio",
                    name: "clinica",
                    value: "3",
                    colonna: 4,
                    smallLabel: true
                },
                clinicaNonNoto: {
                    id: "clinicaNonNoto",
                    text: "SchedaSpecialeTubercolosi.nonNoto",
                    tipo: "radio",
                    name: "clinica",
                    value: "4",
                    colonna: 5,
                    smallLabel: true
                },

            },
            {
                label: {text: "SchedaSpecialeTubercolosi.Mantoux", tipo: "label", colonna: 1, asterisco: true},
                mantouxSi: {
                    id: "mantouxSi",
                    text: "SchedaSpecialeTubercolosi.positivo",
                    tipo: "radio",
                    name: "mantoux",
                    value: "1",
                    colonna: 2,
                    smallLabel: true
                },
                mantouxNo: {
                    id: "mantouxNo",
                    text: "SchedaSpecialeTubercolosi.negativo",
                    tipo: "radio",
                    name: "mantoux",
                    value: "2",
                    colonna: 3,
                    smallLabel: true
                },
                mantouxNonEseguito: {
                    id: "mantouxNonEseguito",
                    text: "SchedaSpecialeTubercolosi.nonEseguito",
                    tipo: "radio",
                    name: "mantoux",
                    value: "3",
                    colonna: 4,
                    smallLabel: true
                },
                mantouxNonNoto: {
                    id: "mantouxNonNoto",
                    text: "SchedaSpecialeTubercolosi.nonNoto",
                    tipo: "radio",
                    name: "mantoux",
                    value: "4",
                    colonna: 5,
                    smallLabel: true
                },

            },
            {
                label: {
                    text: "SchedaSpecialeTubercolosi.rxToraceEsamiStrumentali",
                    tipo: "label",
                    colonna: 1,
                    asterisco: true
                },
                rxToraceEsamiStrumentaliSi: {
                    id: "rxToraceEsamiStrumentaliSi",
                    text: "SchedaSpecialeTubercolosi.positivo",
                    tipo: "radio",
                    name: "rxToraceEsamiStrumentali",
                    value: "1",
                    colonna: 2,
                    smallLabel: true
                },
                rxToraceEsamiStrumentaliNo: {
                    id: "rxToraceEsamiStrumentaliNo",
                    text: "SchedaSpecialeTubercolosi.negativo",
                    tipo: "radio",
                    name: "rxToraceEsamiStrumentali",
                    value: "2",
                    colonna: 3,
                    smallLabel: true
                },
                rxToraceEsamiStrumentaliNonEseguito: {
                    id: "rxToraceEsamiStrumentaliNonEseguito",
                    text: "SchedaSpecialeTubercolosi.nonEseguito",
                    tipo: "radio",
                    name: "rxToraceEsamiStrumentali",
                    value: "3",
                    colonna: 4,
                    smallLabel: true
                },
                rxToraceEsamiStrumentaliNonNoto: {
                    id: "rxToraceEsamiStrumentaliNonNoto",
                    text: "SchedaSpecialeTubercolosi.nonNoto",
                    tipo: "radio",
                    name: "rxToraceEsamiStrumentali",
                    value: "4",
                    colonna: 5,
                    smallLabel: true
                },

            },
            {
                label: {
                    text: "SchedaSpecialeTubercolosi.rispostaAllaTerapia",
                    tipo: "label",
                    colonna: 1,
                    asterisco: true
                },
                rispostaAllaTerapiaSi: {
                    id: "rispostaAllaTerapiaSi",
                    text: "SchedaSpecialeTubercolosi.positivo",
                    tipo: "radio",
                    name: "rispostaAllaTerapia",
                    value: "1",
                    colonna: 2,
                    smallLabel: true
                },
                rispostaAllaTerapiaNo: {
                    id: "rispostaAllaTerapiaNo",
                    text: "SchedaSpecialeTubercolosi.negativo",
                    tipo: "radio",
                    name: "rispostaAllaTerapia",
                    value: "2",
                    colonna: 3,
                    smallLabel: true
                },
                rispostaAllaTerapiaNonEseguito: {
                    id: "rispostaAllaTerapiaNonEseguito",
                    text: "SchedaSpecialeTubercolosi.nonEseguito",
                    tipo: "radio",
                    name: "rispostaAllaTerapia",
                    value: "3",
                    colonna: 4,
                    smallLabel: true
                },
                rispostaAllaTerapiaNonNoto: {
                    id: "rispostaAllaTerapiaNonNoto",
                    text: "SchedaSpecialeTubercolosi.nonNoto",
                    tipo: "radio",
                    name: "rispostaAllaTerapia",
                    value: "4",
                    colonna: 5,
                    smallLabel: true
                },

            },
            {
                label: {
                    text: "SchedaSpecialeTubercolosi.riscontroAutopicoTb",
                    tipo: "label",
                    colonna: 1,
                    asterisco: true
                },
                riscontroAutopicoTbSi: {
                    id: "riscontroAutopicoTbSi",
                    text: "SchedaSpecialeTubercolosi.positivo",
                    tipo: "radio",
                    name: "riscontroAutopicoTb",
                    value: "1",
                    colonna: 2,
                    smallLabel: true
                },
                riscontroAutopicoTbNo: {
                    id: "riscontroAutopicoTbNo",
                    text: "SchedaSpecialeTubercolosi.negativo",
                    tipo: "radio",
                    name: "riscontroAutopicoTb",
                    value: "2",
                    colonna: 3,
                    smallLabel: true
                },
                riscontroAutopicoTbNonEseguito: {
                    id: "riscontroAutopicoTbNonEseguito",
                    text: "SchedaSpecialeTubercolosi.nonEseguito",
                    tipo: "radio",
                    name: "riscontroAutopicoTb",
                    value: "3",
                    colonna: 4,
                    smallLabel: true
                },
                riscontroAutopicoTbNonNoto: {
                    id: "riscontroAutopicoTbNonNoto",
                    text: "SchedaSpecialeTubercolosi.nonNoto",
                    tipo: "radio",
                    name: "riscontroAutopicoTb",
                    value: "4",
                    colonna: 5,
                    smallLabel: true
                },

            }
        ]

        let boxes = Utils.createDiv("col-lg-3", "col-lg-2", "col-lg-2", this.riceviValore, this.state.caratteristicheDellaDiagnosi, t, rows, "col-lg-2", "col-lg-1", "col-lg-2")
        return this.setState({boxes: boxes})
    }

    render() {

        const {t} = this.props

        const caratteristicheDellaDiagnosi = (

            <div style={{marginTop: "1rem"}}>
                <h6>{t("SchedaSpecialeTubercolosi.caratteristicheDellaDiagnosi")} </h6>
                <hr className={styles.hr}/>
                <div className={"container"}>
                    <h6 style={{fontSize: "18px"}}>{t("SchedaSpecialeTubercolosi.Criteri")}
                        <span style={{fontWeight: "normal"}}> {t("SchedaSpecialeTubercolosi.Diagnosibasatasu")} </span>
                    </h6>
                    {this.state.boxes}

                    <div className={"row"}>
                        <div className={"col-lg-3"}>
                            <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                                {t("SchedaSpecialeTubercolosi.motivoIterDiagnostico")}
                                <span className={styles.mandatoryColor}>*</span></p>
                        </div>
                        <div className={"col-lg-9"}>
                            <RadioButton id={"motivoIterDiagnosticoSospetto"} name={"motivoIterDiagnostico"}
                                         label={t("SchedaSpecialeTubercolosi.SospettoClinico")}
                                         style={{color: "black", fontSize: "14px"}}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         smallLabel={true} value={"1"}
                                         checked={this.state.caratteristicheDellaDiagnosi.motivoIterDiagnostico === "1"}>
                            </RadioButton>

                            <div className={"row"}>
                                <div className={"col-lg-5"}>
                                    <RadioButton id={"motivoIterDiagnosticoIndividuato"} name={"motivoIterDiagnostico"}
                                                 label={t("SchedaSpecialeTubercolosi.Casoindividuato")}
                                                 style={{color: "black", fontSize: "14px"}}
                                                 newRadio={true}
                                                 required={this.state.caratteristicheDellaDiagnosi.motivoIterDiagnostico === "2"}
                                                 onClick={this.riceviValore}
                                                 smallLabel={true} value={"2"}
                                                 checked={this.state.caratteristicheDellaDiagnosi.motivoIterDiagnostico === "2"}>
                                    </RadioButton>
                                </div>
                                <div className={"col-lg-6"}
                                     style={{opacity: this.state.caratteristicheDellaDiagnosi.motivoIterDiagnostico !== "2" ? "0.5" : ""}}>
                                    <Select
                                        value={this.state.caratteristicheDellaDiagnosi.eventualeCasoIterDiagnostico}
                                        id={"eventualeCasoIterDiagnostico"}
                                        field={"eventualeCasoIterDiagnostico"}
                                        disabled={this.state.caratteristicheDellaDiagnosi.motivoIterDiagnostico !== "2" ? true : false}
                                        newSelect={true}
                                        onChange={this.riceviValore}
                                        functionMap={Utils.mapToArray(OggettiUtili.IndividuazionePostScreen).map((oggetto) => {
                                            return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                        })}
                                    >
                                    </Select>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.caratteristicheDellaDiagnosi.eventualeCasoIterDiagnostico === "01" ?
                        <div className={"row"}>
                            <div className={"col-lg-3"}/>
                            <div className={"col-lg-9"}>
                                <div className={"row"}>
                                    <div className={"col-lg-5"}/>
                                    <div className={"col-lg-6"}>
                                        <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                                            {t("SchedaSpecialeTubercolosi.screeningContatti")}
                                            <span className={styles.mandatoryColor}>*</span>
                                        </p>
                                        <Select
                                            value={this.state.caratteristicheDellaDiagnosi.screeningContatti}
                                            id={"screeningContatti"}
                                            field={"screeningContatti"}
                                            newSelect={true}
                                            onChange={this.riceviValore}
                                            functionMap={Utils.mapToArray(OggettiUtili.ScreeningContatti).map((oggetto) => {
                                                return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                            })}
                                        >
                                        </Select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : this.state.caratteristicheDellaDiagnosi.eventualeCasoIterDiagnostico === "02" ?
                            <div className={"row"}>
                                <div className={"col-lg-3"}/>
                                <div className={"col-lg-9"}>
                                    <div className={"row"}>
                                        <div className={"col-lg-5"}/>
                                        <div className={"col-lg-6"}>
                                            <p style={{color: "black", marginTop: "0.5rem", fontWeight: "bold"}}>
                                                {t("SchedaSpecialeTubercolosi.gruppiARischio")}
                                                <span className={styles.mandatoryColor}>*</span>
                                            </p>
                                            <div className={"row"}>
                                                <div className={"col-lg-3"}>
                                                    <Select
                                                        value={this.state.caratteristicheDellaDiagnosi.gruppiARischio}
                                                        id={"gruppiARischio"}
                                                        field={"gruppiARischio"}
                                                        newSelect={true}
                                                        onChange={this.riceviValore}
                                                        functionMap={Utils.mapToArray(OggettiUtili.gruppiARischio).map((oggetto) => {
                                                            return (<option
                                                                value={oggetto.codice}>{oggetto.descrizione}</option>)
                                                        })}
                                                    >
                                                    </Select>
                                                </div>
                                                <div className={"col-lg-3"}>
                                                    <Select
                                                        value={this.state.caratteristicheDellaDiagnosi.fattoreDiRischio}
                                                        id={"fattoreDiRischio"}
                                                        field={"fattoreDiRischio"}
                                                        newSelect={true}
                                                        onChange={this.riceviValore}
                                                        functionMap={
                                                            Utils.mapToArray(this.state.caratteristicheDellaDiagnosi.gruppiARischio === "1" ?
                                                                OggettiUtili.fattoriDiRischioA : this.state.caratteristicheDellaDiagnosi.gruppiARischio === "2" ?
                                                                    OggettiUtili.fattoriDiRischioB : "").map((oggetto) => {
                                                                return (<option
                                                                    value={oggetto.codice}>{oggetto.descrizione}</option>)
                                                            })}
                                                    >
                                                    </Select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : ""}
                </div>
            </div>
        )

        return (
            <div>
                {caratteristicheDellaDiagnosi}
            </div>
        );
    }
}

export default withTranslation('common')(caratteristicheDellaDiagnosiTubercolosi)
